import { useEffect } from 'react';
import { Root } from './root';
import { TelegramBoot } from './telegram-boot';
import { PanelRoot } from '@/panel/panel-root';
import { PwaPrompt } from '@/lib/pwa';
import { isPanelHostname, panelHref } from '@/lib/panel-navigation';

type HostLocation = Pick<Location, 'hostname' | 'origin' | 'pathname' | 'port' | 'replace'>;

function PanelRedirect({ location }: { location: HostLocation }) {
  const href = panelHref(location);
  useEffect(() => location.replace(href), [href, location]);
  return (
    <main className="grid min-h-screen place-items-center p-6">
      <a href={href}>Открыть панель администрирования</a>
    </main>
  );
}

export function HostApplication({ location }: { location: HostLocation }) {
  if (isPanelHostname(location.hostname)) return <PanelRoot />;
  if (location.pathname === '/admin' || location.pathname.startsWith('/admin/')) {
    return <PanelRedirect location={location} />;
  }
  return (
    <>
      <TelegramBoot><Root /></TelegramBoot>
      <PwaPrompt />
    </>
  );
}
